<template>
  <div class="pay-trans-details">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.receiver_type') }}</div>
              <el-select v-model="search.receiver_type" filterable class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in receiverTypeMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.receiver_account') }}</div>
              <el-input v-model="search.receiver_account" size="small" type="text" class="filter-item-value" clearable />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.receiver_name') }}</div>
              <el-input v-model="search.receiver_name" size="small" type="text" class="filter-item-value" clearable />
            </div>

            <div class="filter-item">
              <!-- <div class="filter-item-label">{{ $t('customerService.app_name') }}</div>
              <el-input v-model="search.app_name" size="small" type="text" class="filter-item-value" clearable /> -->
            </div>
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter()">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>

    <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-plus" @click="$refs.splitReceiverModal.showModal()">{{ $t('data.add_receiver') }}</el-button>
    <div style="margin-bottom: 15px;">{{ $t('tips.add_receiver_tips', {count: max_receiver_count}) }}</div>
    
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('data.receiver_type')" align="center">
          <template slot-scope="scope">
            <span>{{ receiverTypeMapLable(scope.row.receiver_type) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.receiver_account')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.receiver_account }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.receiver_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.receiver_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.receiver_relation')" align="center">
          <template slot-scope="scope">
            <span>{{ getReceiverRelationMapLabel(scope.row.relation_type) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.nick_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.remark_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.relation_document')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.relation_proof_url ? $t('data.uploaded') : $t('data.not_uploaded') }}</span>
          </template>
        </el-table-column>

        <!--操作-->
        <el-table-column :label="$t('components.operation')" align="center" min-width="100">
          <template slot-scope="scope">
            <!-- <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickEditBtn(scope.row)" />
            </el-tooltip> -->
            <svg-icon class-name="icon-function " icon-class="operation-edit" @click="onClickEditBtn(scope.row)" />
            <!-- <el-popover
              placement="top"
              width="160"
              v-model="visible">
              <p>{{ $t('tips.split_receiver_delete_tips') }}</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible = false">{{ $t('components.cancel') }}</el-button>
                <el-button type="primary" size="mini" @click="onClickDelete(scope.row)">{{ $t('components.confirm') }}</el-button>
              </div>
               <svg-icon slot="reference" class-name="icon-function " icon-class="operation-delete" />
            </el-popover> -->
            <svg-icon class-name="icon-function " icon-class="operation-delete" @click="onClickDelete(scope.row)" />
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
    <SplitReceiverModal ref="splitReceiverModal" @submit="handleFilter" />
  </div>
</template>

<script>

import { PostGetSplitPaymentReceiverList, PostSplitPaymentReceiverDelete } from '@/api/data/data'


import {
  receiverRelationMap,
  receiverTypeMap
} from '@/utils/maps'
import { filterEmptyAttr } from '@/utils/common'

export default {
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    SplitReceiverModal: () => import('./Modal/SplitReceiverModal')
  },
  data() {
    return {
      showFilterContent: true,
      visible: true,
      search: {},
      tableData: [{}],
      max_receiver_count: 0,
      total_fee: 0,
      total_count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    receiverTypeMap() {
      return receiverTypeMap().filter(item => item.value === 1)
    },
    receiverTypeMapLable() {
      return function(val) {
        return receiverTypeMap(val).label
      }
    },
    getReceiverRelationMapLabel() {
      return function(val) {
        return receiverRelationMap(val).label
      }
    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    getTableData(params) {
      this.listLoading = true
      PostGetSplitPaymentReceiverList(params).then(res => {
        // eslint-disable-next-line no-unused-vars
        const { total = 15, list = [], current = 1, max_receiver_count } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.max_receiver_count = max_receiver_count
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { ...otherSearch } = this.search
      let params = {
        ...otherSearch,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getTableData(params)
    },

    onClickEditBtn(row) {
      this.$refs.splitReceiverModal.showModal(JSON.parse(JSON.stringify(row)))
    },

    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickDelete(row) {
      this.$confirm(this.$t('tips.split_receiver_delete_tips'), this.$t('components.tips'), {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        PostSplitPaymentReceiverDelete({ bind_no: row.bind_no }).then(res => {
          this.$message.success('Success')
          this.handleFilter()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pay-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    width: 230px
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }
}
.is-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.is-disabled:hover {
  color: #98A1B4;
}
</style>
